/* eslint-disable camelcase */
import { Platform } from 'react-native';
import FontAwesome_ttf from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
// import Entypo_ttf from 'react-native-vector-icons/Fonts/Entypo.ttf';


function init() {
    if (Platform.OS === "android" || Platform.OS === "ios") {
        return;
    }
    const IconsCSS = `
    @font-face {
      src: url(${FontAwesome_ttf});
      font-family: FontAwesome;
    }
    
    `;

    const style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet) style.styleSheet.cssText = IconsCSS;
    else style.appendChild(document.createTextNode(IconsCSS));

    document.head.appendChild(style);
}

init();